import { render } from "./CometChatSenderFileMessageBubble.vue?vue&type=template&id=10f0090c&scoped=true"
import script from "./CometChatSenderFileMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatSenderFileMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatSenderFileMessageBubble.vue?vue&type=style&index=0&id=10f0090c&scoped=true&lang=css"
import "./CometChatSenderFileMessageBubble.vue?vue&type=style&index=1&id=10f0090c&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f0090c"]])

export default __exports__